import { render } from "./PVDataTableListenansicht.vue?vue&type=template&id=2041f108"
import script from "./PVDataTableListenansicht.vue?vue&type=script&lang=js"
export * from "./PVDataTableListenansicht.vue?vue&type=script&lang=js"

import "./PVDataTableListenansicht.vue?vue&type=style&index=0&id=2041f108&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__